function requiredValidator({ fieldType, fieldValue, requiredErrorMsg }) {
  if (
    fieldValue === '' ||
    fieldValue === null ||
    (fieldType === 'BOOLEAN' && fieldValue === false)
  ) {
    return requiredErrorMsg;
  }
  return null;
}

export default requiredValidator;
